var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEquipmentMaterialInside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 15.75H1.125V16.875H16.875V15.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 1.125L4.2675 1.92L5.7225 3.375H1.125V4.5H5.7225L4.2675 5.955L5.0625 6.75L7.875 3.9375L5.0625 1.125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1125 7.305H14.5275V6.6375C14.5275 6.1125 14.1075 5.6925 13.5975 5.6925H9.2775C8.7675 5.6925 8.3475 6.12 8.3475 6.6375V7.305H7.7625C6.8325 7.305 6.075 8.0625 6.075 8.9925V13.035C6.075 13.965 6.8325 14.7225 7.7625 14.7225H15.105C16.035 14.7225 16.7925 13.965 16.7925 13.035V8.9925C16.7925 8.0625 16.035 7.305 15.105 7.305H15.1125ZM9.4725 6.8175H13.395V7.305H9.4725V6.8175ZM7.7625 8.43H15.105C15.4125 8.43 15.6675 8.685 15.6675 8.9925V9.51H7.2V8.9925C7.2 8.685 7.455 8.43 7.7625 8.43ZM10.8075 10.635H12.0675V11.355H10.8075V10.635ZM7.77 13.59C7.4625 13.59 7.2075 13.335 7.2075 13.0275V10.635H9.69V12.48H13.2V10.635H15.6825V13.0275C15.6825 13.335 15.4275 13.59 15.12 13.59H7.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEquipmentMaterialInside);
export default __webpack_public_path__ + "static/media/ic-equipment-material-inside.9ac7033a86a6b14d19f555a3636775f0.svg";
export { ForwardRef as ReactComponent };